export default {
  area: "随州市智慧养老",
  objectName: "",
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  hostUrl: 'https://sz.anluoyun.cn',
  apiHttpsUrl: 'https://sz.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://sz.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://sz.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://sz.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://szso.anluoyun.cn/prod-api/So/',
}
